import React, { Component } from 'react';
import AdminMenu from '../../Modules/AdminMenu'
import MededelingToevoegen from '../../Modules/Mededelingen/Add'

class MededelingAdd extends Component {

  render() {
    return (
      <div className="route">
      <AdminMenu />
        <h1 className="pageTitle">
          Mededeling toevoegen
          </h1>
          <div className="grey-bg">
            <MededelingToevoegen />
          </div>
      </div>
    );
  }  
}

export default MededelingAdd;



// WEBPACK FOOTER //
// ./src/components/Admin/Pages/Mededelingen/Add.js